import 'client-only';

import { useMemo } from 'react';

import { type Card } from '@/types/productSelectionAndCheckout/types';

import { useProductSelectionAndCheckoutCommonData } from './useProductSelectionAndCheckoutCommonData';
import { useTrialSizeItemPrices } from './useTrialSizeItemPrices';

export const useCardTrialSizeItemPrices = (card: Card) => {
  const { flags } = useProductSelectionAndCheckoutCommonData();
  const isTwoMonthFirstShipment = flags.isTwoMonthFirstShipment;
  const trialSizeItemPrices = useTrialSizeItemPrices();

  return useMemo(() => {
    const cardItemId = isTwoMonthFirstShipment
      ? card.fullSizeItemId
      : card.trialSizeItemId;

    if (cardItemId) {
      const potentialItemPrices = trialSizeItemPrices?.[cardItemId];
      if (!potentialItemPrices) {
        throw new Error(
          `No trial size item prices found for card item ID ${cardItemId}`,
        );
      }

      return potentialItemPrices;
    }

    const cardItemIds = isTwoMonthFirstShipment
      ? card.fullSizeItemIds
      : card.trialSizeItemIds;

    if (cardItemIds) {
      const cardTrialSizePrices = {
        adjustmentAmount: 0,
        finalAmount: 0,
        originalAmount: 0,
      };

      for (let index = 0; index < cardItemIds.length; index += 1) {
        const trialSizeItemId = cardItemIds[index];
        const trialSizeItemPrice = {
          ...trialSizeItemPrices?.[trialSizeItemId],
        };

        cardTrialSizePrices.adjustmentAmount +=
          trialSizeItemPrice?.adjustmentAmount || 0;

        cardTrialSizePrices.finalAmount += trialSizeItemPrice?.finalAmount || 0;

        cardTrialSizePrices.originalAmount +=
          trialSizeItemPrice?.originalAmount || 0;
      }

      return cardTrialSizePrices;
    }
  }, [card, isTwoMonthFirstShipment, trialSizeItemPrices]);
};
